import { useNavigate, useLocation } from "react-router-dom";
import { roleToDefaultRoute, Role } from "@/lib/roles";
import { useAuth } from "@/contexts/AuthContext";
import { useAuthNavigation } from "./useAuthNavigation";

export function usePostLoginRedirect() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const { handlePostLoginRedirect: authNavRedirect } = useAuthNavigation();

  async function onLoginSuccess(_user: any) {
    const roles = (user?.roles as Role[] | undefined) ?? [];

    console.log("🔍 DEBUG - Location search:", location.search);

    // Vérifier d'abord si useAuthNavigation a une destination stockée
    const intendedDestinationKey = 'intended_destination';
    const authNavDestination = sessionStorage.getItem(intendedDestinationKey);

    // Ensuite vérifier les anciennes méthodes pour la compatibilité
    const nextFromStorage = sessionStorage.getItem("returnTo") || undefined;
    const nextFromQuery =
      new URLSearchParams(location.search).get("next") || undefined;
    const requested = nextFromQuery || authNavDestination || nextFromStorage;

    console.log("🔍 DEBUG - authNavDestination:", authNavDestination);
    console.log("🔍 DEBUG - nextFromQuery:", nextFromQuery);
    console.log("🔍 DEBUG - nextFromStorage:", nextFromStorage);
    console.log("🔍 DEBUG - requested:", requested);
    console.log("🔍 DEBUG - Firebase roles:", roles);

    if (requested) {
      console.log("✅ Redirecting to requested path:", requested);
      sessionStorage.removeItem("returnTo");
      sessionStorage.removeItem(intendedDestinationKey);
      return navigate(requested, { replace: true });
    }

    // Si pas de destination demandée, utiliser la logique de useAuthNavigation
    console.log("✅ Using useAuthNavigation logic for post-login redirect");
    authNavRedirect();
  }

  return { onLoginSuccess };
}
